import { Theme } from "@mui/material/styles";
import { StyleRulesCallback } from "@mui/styles/withStyles";
import { ICompanyAvatarProps } from "./CompanyAvatar";

export const styles: StyleRulesCallback<Theme, ICompanyAvatarProps> = ({
  palette,
}) => ({
  root: {
    backgroundColor: palette.common.white,
    border: `1px solid ${palette.gray.light}`,
  },
  fallback: {
    backgroundColor: palette.common.white,
  },
  sm: {
    width: "15px",
    height: "15px",
  },
  md: {
    width: "28px",
    height: "28px",
  },
  lg: {
    width: "30px",
    heigt: "30px",
  },
});
